var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloudSetup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 26,
    viewBox: "0 0 52 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8121 12.6083C-3.34491 6.42365 -0.259709 24.9775 4.14799 24.9775C5.95887 24.9775 9.71262 25.4356 14.2862 25.4356H28.1707C45.8015 25.4356 50.8705 24.214 51.0911 23.8322C52.6338 11.692 43.304 12.8373 38.3086 14.2117C39.1166 9.70686 38.2644 0.605567 28.3907 0.239072C18.517 -0.127424 17.2243 8.33251 17.8121 12.6083Z",
    fill: "#B9F3FB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudSetup);
export default __webpack_public_path__ + "static/media/cloud_setup.69841f6d824af3ec77f11b1f1055bfce.svg";
export { ForwardRef as ReactComponent };